<template>
  <div class="w-full h-[1040px] mt-3 justify-between bg-white space-y-9 rounded-t-[20px]">
  <NavbarComponent />
  <div class="mx-8 my-6">
    <div class="hr-container space-x-5 mb-6 ">
      <div class="flex items-center justify-between">
        <div class=" space-y-3">
          <p class="font-semibold text-bodyText text-[20px]">Activity Dump</p>
          <p class="text-bodyText text-[14px]">This table holds all activities that weren't added to the right place in the activity table because one issue or the other.</p>
        </div>
      </div>
    </div>
      <div class="flex ml-auto justify-between mb-8 space-x-6 py-1 text-[14px] rounded-[6px] items-center">
        <p class="flex items-center cursor-pointer gap-2 rounded-[6px] bg-[#FFFFFF] bg-[14px] px-4 py-1 border border-grayLight">
          <img src="@/assets/projects/sort.svg" alt="Icon" class="">            
          Filters
        </p>
      </div>
      <ActivityDumpTable />
  </div>

  </div>
</template>

<script>
import NavbarComponent from '../NavbarComponent.vue';
import ActivityDumpTable from './ActivityDumpTable.vue';

export default {
  name: 'ActivityDumpComponent',
  components: {
      NavbarComponent,
      ActivityDumpTable,
  },
  data() {
      return {
        viewMode: 'list',
      };
  },
  computed: {
      isAdmin() {
          return this.$store.getters.isAdmin;
      },
  },
  methods: {
    setViewMode(mode) {
      this.viewMode = mode;
    },
      
  }
};
</script>
